import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { PrivacyPage } from "@/components/pages/PrivacyPage";
import { nl } from "@/i18n/nl";

export const Route = createFileRoute("/nl/privacy")({
  head: () =>
    buildHead({
      lang: "nl",
      page: "home",
      title: nl.privacy.page.title + " · 2AM Hospitality",
      description: nl.privacy.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "nl") i18n.changeLanguage("nl");
    }, []);
    if (i18n.language !== "nl") i18n.changeLanguage("nl");
    return <PrivacyPage />;
  },
});
